export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14645.0e9874b1.jpg";